export const companyCopyrightInfo: string =
  // Copyright code
  `${String.fromCodePoint(
    0x00a9
  )} 2023 Lombardi & Boeing Advogados Associados. OAB/SC 7052/2021. Todos os direitos reservados.`;
